import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { memo } from "react";

interface ConfirmEditAddressModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const ConfirmEditAddressModal = memo(function ConfirmEditAddressModal({
  isOpen,
  onConfirm,
  onClose,
}: ConfirmEditAddressModalProps) {
  return (
    <RedoModal
      isOpen={isOpen}
      modalSize="sm"
      onModalCloseRequested={onClose}
      primaryButton={{ text: "Confirm", onClick: onConfirm }}
      secondaryButton={{ text: "Cancel", onClick: onClose }}
      subtitle="Failed to update address in the external sales channel - would you like to update the address in Redo only?"
      title="Confirm edit address"
    />
  );
});
